import type {FC} from 'react';

import type {CheckboxesAnswerModel} from '../../../../../../../core/domain/Answer/CheckboxesAnswer/CheckboxesAnswer.model';
import type {ChoiceQuestionModel} from '../../../../../../../core/domain/Question/ChoiceQuestion/ChoiceQuestion.model';
import type {QuestionProps} from '../types';

import {CheckboxesAnswerFactory} from '../../../../../../../core/domain/Answer/CheckboxesAnswer/CheckboxesAnswerFactory';
import {useInjection} from '../../../../../../../IoC';
import {Checkbox} from '../../../../../../../uikit/Checkbox';
import {Text} from '../../../../../../../uikit/Text';
import {platform} from '../../../../../../../utils/platform';
import * as S from './styles';

export const CheckboxesQuestion: FC<
  QuestionProps<ChoiceQuestionModel, CheckboxesAnswerModel>
> = ({answer, onAnswerChange, question}) => {
  const answerFactory = useInjection(CheckboxesAnswerFactory);

  const onOptionClick = (optionId: string, isSelected: boolean) => {
    const newOptionIds = new Set(answer ? answer.value : []);

    if (isSelected) {
      newOptionIds.add(optionId);
    } else {
      newOptionIds.delete(optionId);
    }

    onAnswerChange?.(
      answerFactory.create({
        question,
        value: newOptionIds.size ? Array.from(newOptionIds.values()) : null,
      }),
    );
  };

  return (
    <S.Container>
      {question.options.map(option => {
        const isSelected = answer?.value?.includes(option.id) ?? false;

        return (
          <S.Option
            key={option.id}
            onClick={() => onOptionClick(option.id, !isSelected)}
          >
            <Checkbox
              checked={isSelected}
              onClick={
                platform.isNative
                  ? () => onOptionClick(option.id, !isSelected)
                  : undefined
              }
            />
            <Text>{option.title}</Text>
          </S.Option>
        );
      })}
    </S.Container>
  );
};
